import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { advisorAdminApi, type ManageReportingAttributeData } from '../api/api';

export function useManageReportingAttribute() {
  const mutation = useMutation({
    mutationFn: ({
      advisorId,
      ...data
    }: ManageReportingAttributeData & { advisorId: string }) =>
      advisorAdminApi.manageReportingAttribute(advisorId, data),
    onSuccess: (data) => {
      toast.success(typeof data === 'string' ? data : 'Reporting attribute updated successfully');
    },
  });

  return {
    manageAttribute: mutation.mutate,
    isPending: mutation.isPending,
    isError: mutation.isError,
    error: mutation.error,
    errorMessage: mutation.error?.message ?? null,
    reset: mutation.reset,
  };
}
